var map = {
	"./album/routes.js": 479,
	"./alibi/routes.js": 476,
	"./dashboard/routes.js": 480,
	"./download/routes.js": 439,
	"./keyword/routes.js": 441,
	"./latest/routes.js": 443,
	"./placement/routes.js": 445,
	"./playlist/routes.js": 484,
	"./premium/routes.js": 451,
	"./project/routes.js": 482,
	"./report/routes.js": 459,
	"./setting/routes.js": 461,
	"./sfx/routes.js": 477,
	"./track/routes.js": 478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 414;